import { Icon } from "@chakra-ui/react";
import { DfLogoIcon } from "../../icons";

/**
 * Application Logo component
 */
export function Logo() {
  return (
    <Icon as={DfLogoIcon} w="87px" h="30px" />
  );
}
